/*
 * @Description: 产品查询影像数据存储
 * @Author: jerry
 */
export default {
  namespaced: true,
  state: {
    mappubObj: {},
    // 图层id
    publicklayerid: "",
    //1行政区域重点类；2文本shp类；3自定义空间
    publickBtntype: "",
    querytype: "", //区域类型(行政—1，重点—2，文本导入—3，shp导入—4，自定义—3)
    //公共区域code
    publickCode: "",
    // 产品查询-分辨率集合
    resolution: ["10000"],
    // 产品查询-其他分辨率
    resolutions: "",
    //所有卫星
    satelliteMap: [],
    //产品级别
    productLevel: "",
    // 云量
    clundNum: 100,
    // 图像存储坐标等信息
    imageInfo: [],
    // 工具绘制坐标存储
    toolInfo:'',
    // 控制图像显示隐藏id
    imageSwitchInfo:{}
  },
  getters: {},
  mutations: {
    setImageSwitch(state, data) {
      state.imageSwitchInfo = data;
    },
    setToolInfo(state, data) {
        state.toolInfo = data;
      },
    setImageInfo(state, data) {
      state.imageInfo = data;
    },
    setPublicklayerid(state, data) {
      state.publicklayerid = data;
    },
    setPublickBtntype(state, data) {
      state.publickBtntype = data;
    },
    setPublickCode(state, data) {
      state.publickCode = data;
    },
    setResolution(state, data) {
      state.resolution = data;
    },
    setResolutions(state, data) {
      state.resolutions = data;
    },
    setSatellitemap(state, data) {
      state.satelliteMap = data;
    },
    setPublickLevel(state, data) {
      state.productLevel = data;
    },
    setCloundNum(state, data) {
      state.clundNum = data;
    },
    SET_MAPPUBOBJ(state, data) {
      console.log(data);
      state.mappubObj = data;
    },
    SET_QUERYTYPE(state, data) {
      state.querytype = data;
    },
  },
  actions: {
    updateImageSwitch({ commit }, data) {
      commit("setImageSwitch", data);
    },
    updateToolInfo({ commit }, data) {
        commit("setToolInfo", data);
      },
    upImageInfo({ commit }, data) {
      commit("setImageInfo", data);
    },
    updateMappubObj({ commit }, data) {
      commit("SET_MAPPUBOBJ", data);
    },
    updateQuerytype({ commit }, data) {
      commit("SET_QUERYTYPE", data);
    },
    updatePublicklayerid({ commit }, data) {
      commit("setPublicklayerid", data);
    },
    updatePublickBtntype({ commit }, data) {
      commit("setPublickBtntype", data);
    },
    updatePublickCode({ commit }, data) {
      commit("setPublickCode", data);
    },
    updateResolution({ commit }, data) {
      commit("setResolution", data);
    },
    updateResolutions({ commit }, data) {
      commit("setResolutions", data);
    },
    updateSatelliteMap({ commit }, data) {
      commit("setSatellitemap", data);
    },
    updateProductLevel({ commit }, data) {
      commit("setPublickLevel", data);
    },
    updateCloundNum({ commit }, data) {
      commit("setCloundNum", data);
    },
  },
};
